(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-brands"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('customer-brand-marquee')) {
  customElements.define('customer-brand-marquee', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      const toggle = this.querySelector('.customer-brands__toggle');
      this.dataset.ready = 'true';
      this.dataset.paused = 'false';
      if (this.dataset.autoplay !== 'true') return;
      toggle.hidden = false;
      this.onToggle = () => {
        const paused = this.dataset.paused !== 'true';
        this.dataset.paused = String(paused);
        toggle.setAttribute('aria-pressed', String(paused));
        toggle.querySelector('[data-pause-label]').hidden = paused;
        toggle.querySelector('[data-play-label]').hidden = !paused;
      };
      toggle.addEventListener('click', this.onToggle);
    }
    disconnectedCallback() {
      if (this.onToggle) this.querySelector('.customer-brands__toggle')?.removeEventListener('click', this.onToggle);
      delete this.dataset.ready;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-best-sellers"] && !Shopify.designMode) return;
  try {
    
  function initHomeBestSellers(root) {
    if (root.dataset.bestSellersReady === 'true') return;
    root.dataset.bestSellersReady = 'true';
    const rail = root.querySelector('.home-best-sellers__rail');
    const controls = root.querySelector('.home-best-sellers__controls');
    if (!rail || !controls) return;
    const previous = controls.querySelector('[data-direction="previous"]');
    const next = controls.querySelector('[data-direction="next"]');
    const dots = controls.querySelector('.home-best-sellers__dots');
    let stops = [0];
    function refresh() {
      const maximum = Math.max(0, rail.scrollWidth - rail.clientWidth);
      const positions = [...rail.querySelectorAll('.home-best-sellers__slot')].map(card => Math.min(maximum, card.offsetLeft - rail.offsetLeft));
      stops = [...new Set(positions)].filter(value => value >= 0);
      if (!stops.length) stops = [0];
      controls.hidden = maximum < 2;
      dots.replaceChildren();
      if (controls.hidden) return;
      stops.forEach(() => {
        const dot = document.createElement('span');
        dot.className = 'home-best-sellers__dot';
        dots.append(dot);
      });
      update();
    }
    function update() {
      const current = stops.reduce((best, stop, index) => Math.abs(stop - rail.scrollLeft) < Math.abs(stops[best] - rail.scrollLeft) ? index : best, 0);
      previous.disabled = current === 0;
      next.disabled = current === stops.length - 1;
      [...dots.children].forEach((dot, index) => dot.classList.toggle('is-active', index === current));
    }
    function move(direction) {
      const current = stops.reduce((best, stop, index) => Math.abs(stop - rail.scrollLeft) < Math.abs(stops[best] - rail.scrollLeft) ? index : best, 0);
      const target = Math.max(0, Math.min(stops.length - 1, current + direction));
      rail.scrollTo({ left: stops[target], behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    rail.addEventListener('scroll', update, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(refresh).observe(rail);
    refresh();
  }
  document.querySelectorAll('.home-best-sellers').forEach(initHomeBestSellers);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.home-best-sellers').forEach(initHomeBestSellers));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-customer-reviews"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('customer-review-rail')){
  customElements.define('customer-review-rail',class extends HTMLElement{
    connectedCallback(){
      this.track=this.querySelector('[data-review-track]');
      this.prev=this.querySelector('[data-review-prev]');
      this.next=this.querySelector('[data-review-next]');
      if(!this.track||!this.prev||!this.next)return;
      this.updateButtons=()=>{
        this.prev.disabled=this.track.scrollLeft<=2;
        this.next.disabled=this.track.scrollLeft+this.track.clientWidth>=this.track.scrollWidth-2;
      };
      this.move=(direction)=>{
        const card=this.track.querySelector('.customer-review-card');
        if(!card)return;
        const gap=parseFloat(getComputedStyle(this.track).columnGap)||0;
        this.track.scrollBy({left:direction*(card.getBoundingClientRect().width+gap),behavior:'smooth'});
      };
      this.onPrev=()=>this.move(-1);
      this.onNext=()=>this.move(1);
      this.prev.addEventListener('click',this.onPrev);
      this.next.addEventListener('click',this.onNext);
      this.track.addEventListener('scroll',this.updateButtons,{passive:true});
      this.resizeObserver=new ResizeObserver(this.updateButtons);
      this.resizeObserver.observe(this.track);
      requestAnimationFrame(this.updateButtons);
    }
    disconnectedCallback(){
      this.prev?.removeEventListener('click',this.onPrev);
      this.next?.removeEventListener('click',this.onNext);
      this.track?.removeEventListener('scroll',this.updateButtons);
      this.resizeObserver?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-feed"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shop-the-feed')) {
    customElements.define('shop-the-feed', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.rail = this.querySelector('.shop-feed__rail');
        this.videos = [...this.querySelectorAll('video')];
        const controls = this.querySelector('.shop-feed__controls');
        const buttons = [...controls.querySelectorAll('button')];
        const update = () => {
          const max = Math.max(0, this.rail.scrollWidth - this.rail.clientWidth);
          controls.hidden = max < 2 || !this.querySelector('.shop-feed__card');
          buttons[0].disabled = this.rail.scrollLeft < 2;
          buttons[1].disabled = this.rail.scrollLeft > max - 2;
        };
        buttons.forEach(button => button.addEventListener('click', () => {
          const card = this.querySelector('.shop-feed__card');
          if (!card) return;
          const gap = parseFloat(getComputedStyle(this.rail).gap) || 24;
          this.rail.scrollBy({ left: Number(button.dataset.step) * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        }, { signal }));
        this.rail.addEventListener('scroll', update, { signal, passive: true });
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(update);
          this.resizeObserver.observe(this.rail);
        }
        if ('IntersectionObserver' in window) {
          this.visibilityObserver = new IntersectionObserver(entries => entries.forEach(entry => {
            if (!entry.isIntersecting) entry.target.pause();
          }));
          this.videos.forEach(video => this.visibilityObserver.observe(video));
        }
        this.videos.forEach(video => video.addEventListener('play', () => {
          this.videos.forEach(other => { if (other !== video) other.pause(); });
        }, { signal }));
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.videos.forEach(video => video.pause());
        }, { signal });
        update();
      }
      disconnectedCallback() {
        this.videos?.forEach(video => video.pause());
        this.abort?.abort();
        this.abort = null;
        this.resizeObserver?.disconnect();
        this.visibilityObserver?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
